import { useEffect } from "react";
import { useI18n } from "@/i18n";

// The report is delivered by email only: block the print shortcut and put a
// localized notice on the (blanked) print output.
export function usePrintGuard() {
  const { t } = useI18n();
  useEffect(() => {
    document.body.setAttribute("data-print-notice", t("print.blocked"));
    const onKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [t]);
}
